import React from "react";
import { Row, Col, Card, Tooltip, Button, notification, Drawer } from 'antd';
import { TableComp } from 'sz-react-utils'
import Request from "../../request";
import { connect } from "react-redux";
import moment from "moment";
import LatestFollowup from "../_utils/latestFollowup";
import {
    FaMoneyCheckAlt,
    FaRegBuilding,
    FaUserCog
} from "react-icons/fa";
import { RightsWrapper } from "../_utils/utils";

let dateFormat = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')).dateFormat : 'DD.MM.YYYY';



// Dropped Raw Inquiry Drawer
class DroppedRawLeads extends React.Component {
    state = {
        visible: true,
        count: 0,
        loading:false
    }

    onClose = () => {
        this.setState({ visible: false })
        setTimeout(() => {
            this.props.onClose()
        }, 400)
    }
    apiRequest = (params) =>{
        return new Promise(async(resolve)=>{
            params.dropped = true;
            this.setState({loading:true})
            let response = await Request.getAllRawInquiryList({...params, regExFilters:[]})
            this.setState({loading:false})
            this.setState({ count: response.total })
            resolve(response)
        })
    }

    restoreRawDroppedLead = async (recordId) => {
        this.setState({loading:true})
        let response = await Request.restoreRawDroppedLead({ _id: recordId })
        this.setState({loading:false})
        if (response.success) {
            notification.success({
                message: response.message
            })
        } else {
            notification.error({
                message: response.message
            })
        }
        this.table.current.reload();
    }


    constructor(props) {
        super(props)
        this.table = React.createRef()
    }

    render() {
        let { visible, count,loading } = this.state;
        const columns = [
            {
                title: 'Sr No.',
                key: 'serial Number',
                render: (text, record, index) => (
                    <div>{index + 1}</div>
                )
            },
            {
                title: 'Action',
                key: 'operation',
                render: (text, record) => {
                    return (
                        <>
                            <Tooltip title="Restore Lead">
                                <Button shape="circle" icon="backward" size="small" onClick={() => this.restoreRawDroppedLead(record._id)}></Button>
                            </Tooltip>
                        </>
                    )
                }
            },
            {
                title: "VID",
                key: "id",
                width: 100,
                dataIndex: "id",
                sorter: true,
                searchTextName: "id",
                filterRegex: true,
            },
            {
                title: 'Student Name',
                key: 'studentName',
                searchTextName: "studentName",
            },
            {
                title: 'DOB',
                key: 'dateOfBirth',
                render: (text, record) => (
                    <div>{moment(record.dateOfBirth).format(dateFormat)}</div>
                )
            },
            {
                title: 'Mobile',
                key: 'mobile',
                searchTextName: "studentName",
                filterRegex: true
            },
            {
                title: 'Mode',
                key: 'location'
            },
            {
                title: 'FollowUp',
                key: 'followUp',
                render: (text, record) => (
                    <LatestFollowup info={record.followUp} />
                )
            }
        ]
        return (
            <Drawer
                title={
                    <div>
                        <React.Fragment>
                            Dropped Raw Inquiries - {count}
                        </React.Fragment>
                    </div>
                }
                placement="right"
                closable={true}
                onClose={this.onClose}
                width={1100}
                visible={visible}>
                <Card>
                    <TableComp
                        ref={this.table}
                        columns={columns}
                        apiRequest={this.apiRequest}
                        loading={loading}
                        pagination={{
                            showSizeChanger: true,
                            defaultPageSize: 10,
                            pageSizeOptions: ['10', '20', '50', '100', '1000']
                        }}
                    />
                </Card>

            </Drawer>
        )
    }

}

// Dropped Inquiries Drawer
class DroppedInquiries extends React.Component {
    state = {
        visible: true,
        count: 0,
        loading:false
    }

    onClose = () => {
        this.setState({ visible: false })
        setTimeout(() => {
            this.props.onClose()
        }, 400)
    }

    

    restoreDroppedLead = async (recordId) => {
        this.setState({loading:true})
        let response = await Request.restoreDroppedLead({ _id: recordId })
        this.setState({loading:false})
        if (response.success) {
            notification.success({
                message: response.message
            })
        } else {
            notification.error({
                message: response.message
            })
        }
        this.table.current.reload();
    }

    apiRequest = (params) => {
        return new Promise(async (resolve) => {
            params.dropped = true;
            this.setState({loading:true})
            let response = await Request.fetchDroppedInquiries({...params, regExFilters: ["studentName", "watsupp", "mobile", "dateOfBirth"]});
            this.setState({loading:false, count:response.total})
            resolve(response)
        })
    }

    constructor(props) {
        super(props);
        this.table = React.createRef();
    }

    render() {
        let { visible, count,loading } = this.state;
        const columns = [
            {
                title: 'Sr No.',
                key: 'serial Number',
                render: (text, record, index) => (
                    <div>{index + 1}</div>
                )
            },
            {
                title: 'Action',
                key: 'operation',
                render: (text, record) => {
                    return (
                        <>
                            <Tooltip title="Restore Lead">
                                <Button shape="circle" icon="backward" size="small" onClick={() => this.restoreDroppedLead(record._id)}></Button>
                            </Tooltip>
                        </>
                    )
                }
            },
            {
                title: "VID",
                key: "id",
                width: 100,
                dataIndex: "id",
                sorter: true,
                searchTextName: "id",
                filterRegex: true,
            },
            {
                title: 'Student Name',
                key: 'studentName',
                searchTextName: "studentName",
            },
            {
                title: 'DOB',
                key: 'dateOfBirth',
                render: (text, record) => (
                    <div>{moment(record.dateOfBirth).format(dateFormat)}</div>
                )
            },
            {
                title: 'Mobile',
                key: 'mobile',
                searchTextName: "studentName",
                filterRegex: true
            },
            {
                title: 'Mode',
                key: 'location'
            },
            {
                title: 'FollowUp',
                key: 'followUp',
                render: (text, record) => (
                    <LatestFollowup info={record.followUp} />
                )
            }
        ]
        return (
            <Drawer
                title={
                    <div>
                        <React.Fragment>
                            Dropped Inquiries - {count}
                        </React.Fragment>
                    </div>
                }
                placement="right"
                closable={true}
                onClose={this.onClose}
                width={1100}
                visible={visible}>
                <Card>
                    <TableComp
                        ref={this.table}
                        columns={columns}
                        apiRequest={this.apiRequest}
                        loading={loading}
                        pagination={{
                            showSizeChanger: true,
                            defaultPageSize: 10,
                            pageSizeOptions: ['10', '20', '50', '100', '1000']
                        }}
                    />
                </Card>

            </Drawer>
        )
    }
}


class DroppedLeads extends React.Component {
    state = {
        count: 0,
        rawCount: 0,
        droppedInquiryCount: 0,
        droppedRawInquiryCount: 0,
        droppedInquiry: [],
        droppedRawInquiry: [],
        showDroppedInquiry: false,
        showDroppedRawInquiry: false
    }

    loadAllApis = () => {
        Request.getDroppedLeads().then(({ droppedLeadsCount, droppedRawInquiryCount }) => {
            this.setState({ droppedInquiryCount: droppedLeadsCount.total, droppedRawInquiryCount: droppedRawInquiryCount.total })
        })
    }

    showDroppedInquiryDrawer = () => {
        this.setState({ showDroppedInquiry: true })
    }

    showDroppedRawInquiryDrawer = () => {
        this.setState({ showDroppedRawInquiry: true })
    }


    closeDroppedInquiryDrawer = () => {
        this.setState({ showDroppedInquiry: false, showDroppedRawInquiry: false }, ()=>{
            this.loadAllApis()
        })
    }

    componentDidMount = () => {
        this.loadAllApis()
    }


    render() {
        let { count, rawCount, droppedInquiryCount, droppedRawInquiryCount, showDroppedRawInquiry, showDroppedInquiry } = this.state
        
        return (

            <RightsWrapper myRight={"showDropLead.view"}>
                {
                    showDroppedInquiry ?
                        <DroppedInquiries onClose={this.closeDroppedInquiryDrawer} />
                        : null
                }
                {
                    showDroppedRawInquiry?
                    <DroppedRawLeads onClose={this.closeDroppedInquiryDrawer} />
                    :null
                }
                <Row>
                    <Col span={8} style={{ padding: '10px' }}>
                        <div className="info-box">
                            <span className="info-box-icon bg-color-1 elevation-1"><FaRegBuilding /></span>
                            <div className="info-box-content">
                                <span className="info-box-text">Dropped Inquiries</span>
                                <span className="info-box-number">
                                    <a onClick={() => this.showDroppedInquiryDrawer()}>{droppedInquiryCount}</a>
                                </span>
                            </div>
                        </div>
                    </Col>
                    <Col span={8} style={{ padding: '10px' }}>
                        <div className="info-box">
                            <span className="info-box-icon bg-color-2 elevation-1"><FaRegBuilding /></span>
                            <div className="info-box-content">
                                <span className="info-box-text">Dropped Raw Inquiries </span>
                                <span className="info-box-number">
                                    <a onClick={() => this.showDroppedRawInquiryDrawer()}>{droppedRawInquiryCount}
                                    </a>
                                </span>
                            </div>
                        </div>
                    </Col>
                </Row>
            </RightsWrapper>
        )
    }
}


const mapStateToProps = ({ global }) => ({
    categories: global.categories,
    loading: global.buttonLoading,
    currentUser: global.currentUser

})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(mapStateToProps, mapDispatchToProps)
    (DroppedLeads)